import { useTranslation } from 'next-i18next';
import S from './UploadForm/AppUpload.module.scss';
import { AppUploadForm } from './UploadForm/AppUploadForm';
import { _AppUploadGuide } from './components';
export const UploadApp = () => {
  const {
    t
  } = useTranslation(['accounts']);
  return <div className={S.wrapper} data-sentry-component="UploadApp" data-sentry-source-file="UploadApp.tsx">
      <div className={S.title}>{t('accounts:myApp.common.uploadApp')}</div>
      <_AppUploadGuide data-sentry-element="_AppUploadGuide" data-sentry-source-file="UploadApp.tsx" />
      <div className={S.container}>
        <AppUploadForm.Provider data-sentry-element="unknown" data-sentry-source-file="UploadApp.tsx">
          <AppUploadForm.InputName data-sentry-element="unknown" data-sentry-source-file="UploadApp.tsx" />
          <AppUploadForm.InputDescription data-sentry-element="unknown" data-sentry-source-file="UploadApp.tsx" />
          <AppUploadForm.SelectType data-sentry-element="unknown" data-sentry-source-file="UploadApp.tsx" />
          <AppUploadForm.UploadAppIcon data-sentry-element="unknown" data-sentry-source-file="UploadApp.tsx" />
          <AppUploadForm.InputLocalZepFilePath data-sentry-element="unknown" data-sentry-source-file="UploadApp.tsx" />
          <AppUploadForm.UploadFile data-sentry-element="unknown" data-sentry-source-file="UploadApp.tsx" />
          <AppUploadForm.SubmitButton title={t('accounts:myApp.upload.uploadApp')} isUpdated={false} data-sentry-element="unknown" data-sentry-source-file="UploadApp.tsx" />
        </AppUploadForm.Provider>
      </div>
    </div>;
};